module.exports = __webpack_public_path__ + "img/win-icon6.e475c8d.png";